import {
    actions,
    TitleAction,
    DescriptionAction,
} from "./actions";

type ActionTypes =
    | TitleAction
    | DescriptionAction;

export interface InitialState {
    title: string,
    description: string,
};
export interface InitialState {
    title: string,
    description: string,
};

const states: InitialState = {
    title: "",
    description: "",
};

const reducer = (state: InitialState = states, action: ActionTypes): InitialState => {
    switch (action.type) {
        case actions.SET_PAGE_TITLE:
            return {
                ...state,
                title: action.title,
            };
        case actions.SET_PAGE_DESCRIPTION:
            return {
                ...state,
                description: action.description,
            };
        default:
            return state;
    }
};

export default reducer;